const registry = {
  PROPIEDAD: {
    id: 'PROPIEDAD',
    name: 'Propiedad',
    value: 'Propiedad',
    folder: 'properties',
  },
  HIPOTECA: {
    id: 'HIPOTECA',
    name: 'Hipoteca',
    value: 'Hipoteca',
  },
  PROHIBICION: {
    id: 'PROHIBICION',
    name: 'Prohibicion',
    value: 'Prohibicion',
  },
  COMERCIO: {
    id: 'COMERCIO',
    name: 'Comercio',
    value: 'Comercio',
    folder: 'commerce',
  },
  AGUAS: {
    id: 'AGUAS',
    name: 'Aguas',
    value: 'Aguas',
    folder: 'waters',
  },
  MINAS_PROPIEDADES: {
    id: 'MINAS_PROPIEDADES',
    name: 'Propiedad de Minas',
    value: 'Minas',
    folder: 'minesProperties',
  },
  MINAS_DESCUBRIMIENTO: {
    id: 'MINAS_DESCUBRIMIENTO',
    name: 'Descubrimiento de Minas',
    value: 'Minas',
    folder: 'mines',
  },
  DOC_PROPIEDAD: {
    id: 'DOC_PROPIEDAD',
    value: 'Doc. Propiedad',
    name: 'Documento de Propiedad CBR Puerto Varas'
  },
  DOC_HIPOTECA: {
    id: 'DOC_HIPOTECA',
    value: 'Doc. Hipoteca',
    name: 'Documento de Hipoteca CBR Puerto Varas'
  },
  DOC_PROHIBICION: {
    id: 'DOC_PROHIBICION',
    value: 'Doc. Prohibicion',
    name: 'Documento de Prohibición CBR Puerto Varas'
  },
  DOC_COPROPIEDAD: {
    id: 'DOC_COPROPIEDAD',
    value: 'Doc. Copropiedad',
    name: 'Documento de Copropiedad CBR Puerto Varas'
  },
  DOC_COMERCIO: {
    id: 'DOC_COMERCIO',
    value: 'Doc. Comercio',
    name: 'Documento de Comercio CBR Puerto Varas'
  },
  PL_PROPIEDAD: {
    id: 'DOC_PROPIEDAD',
    value: 'Doc. Propiedad',
    name: 'Plano de Propiedad CBR Puerto Varas'
  },
  PL_HIPOTECA: {
    id: 'DOC_HIPOTECA',
    value: 'Doc. Hipoteca',
    name: 'Plano de Hipoteca CBR Puerto Varas'
  },
  PL_PROHIBICION: {
    id: 'DOC_PROHIBICION',
    value: 'Doc. Prohibicion',
    name: 'Plano de Prohibición CBR Puerto Varas'
  },
  PL_COPROPIEDAD: {
    id: 'DOC_COPROPIEDAD',
    value: 'Doc. Copropiedad',
    name: 'Plano de Copropiedad CBR Puerto Varas'
  },
  PL_COMERCIO: {
    id: 'DOC_COMERCIO',
    value: 'Doc. Comercio',
    name: 'Plano de Comercio CBR Puerto Varas'
  },
  DOC_PRIMERA_NOTARIA: {
    id: 'DOC_PRIMERA_NOTARIA',
    value: 'Doc. 1° Puerto Varas',
    name: 'Plano de 1era Notaría Bernardo Espinosa B.'
  },
  DOC_SEGUNDA_NOTARIA: {
    id: 'DOC_SEGUNDA_NOTARIA',
    value: 'Doc. 2° Llanquihue',
    name: 'Plano de 2da Notaría Ricardo Fontecilla G.'
  },
  DOC_TERCERA_NOTARIA: {
    id: 'DOC_TERCERA_NOTARIA',
    value: 'Doc. 3° Puerto Varas',
    name: 'Plano de 3era Notaría Sandra Cárcamo V.'
  },
  PRIMERA_NOTARIA: {
    id: 'PRIMERA_NOTARIA',
    value: '1° Puerto Varas',
    name: '1era Notaría Bernardo Espinosa B.'
  },
  SEGUNDA_NOTARIA: {
    id: 'SEGUNDA_NOTARIA',
    value: '2° Llanquihue',
    name: '2da Notaría Ricardo Fontecilla G.'
  },
  TERCERA_NOTARIA: {
    id: 'TERCERA_NOTARIA',
    value: '3° Puerto Varas',
    name: '3era Notaría Sandra Cárcamo V.'
  },
  PRENDA_AGRARIA: {
    id: 'PRENDA_AGRARIA',
    value: 'Prenda Agraria',
    name: 'Prenda Agraria'
  },
  PRENDA_INDUSTRIAL: {
    id: 'PRENDA_INDUSTRIAL',
    value: 'Prenda Industrial',
    name: 'Prenda Industrial'
  },
  CIVIL: {
    id: 'CIVIL',
    value: 'Civil',
    name: 'Civil'
  },
  CRIMINAL: {
    id: 'CRIMINAL',
    value: 'Criminal',
    name: 'Criminal'
  },
  LABORAL: {
    id: 'LABORAL',
    value: 'Laboral',
    name: 'Laboral'
  },
  MENORES: {
    id: 'MENORES',
    value: 'Menores',
    name: 'Menores'
  },
  ALCOHOLES: {
    id: 'ALCOHOLES',
    value: 'Alcoholes',
    name: 'Alcoholes'
  },
  // Este existe pero para queries de planos debe ser diferente (PL_COPROPIEDAD)
  COPROPIEDAD: {
    id: 'CO PROPIEDAD',
    value: 'CO PROPIEDAD',
    name: 'Co-propiedad'
  },
  MINAS: {
    id: 'MINAS',
    value: 'MINAS',
    name: 'Minas',
  },
  PROTOCOLO: {
    id: 'PROTOCOLO',
    value: 'PROTOCOLO',
    name: 'Protocolo'
  }
}

export default registry